<template>
  <div>
    <div class="tabs">
      <ul>
        <li class="tab"
          :class="{ isActive: tab.isActive }"
          v-for="tab in tabs"
          @click="selectTab(tab)">
          <a :href="tab.href">{{ tab.name }}</a>
        </li>
      </ul>
    </div>
    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { tabs: [] };
  },

  created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.href == selectedTab.href);
      });
    }
  }
}
</script>

<style lang="scss">
.tabs ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tab {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tab a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/Tabs.vue